export enum PaymentModes {
    CASH =	'CD',
    CHEQUE ='CH',
    DEMAND_DRAFT='DD',
    EMAILS_PAYMENT_LINK='EL',
    NEFT_RTGS='NR',
    ONLINE ='PL'
}

export enum PaymentBy {
    CUSTOMER =	'customer',
    Intermediary ='intermediary'
}